export const STATUS_NAMES = {
  APPROVED: 'Approved',
  PUBLISHED: 'Published',
  REJECTED: 'Rejected',
  SUBMITTED: 'Submitted',
  UNSUBMITTED: 'Unsubmitted',
  ARCHIVED: 'Archived',
  DRAFT: 'Draft',
}
